import { createSortSchema, createPaginationSchema } from '@emfood/shared';

export const CsvImportsListSearchParamsSchema = createPaginationSchema({
  defaultPage: 1,
  defaultPageSize: 10,
  allowedPageSizes: [10, 25, 50, 100],
}).concat(createSortSchema(['createdAt', 'processedAt'] as const));
